import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=0d4c6933&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=0d4c6933&lang=stylus&scoped=true&"
import style1 from "./MainHeader.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c6933",
  null
  
)

export default component.exports